import { StorageUnit } from "../../storageComponent/storageFields";

export interface Site {
  id: string | null;
  siteName: string | null;
  address: string | null;
  postcode: string | null;
  status: string | null;
  numberOfFloors: number | null;
  numberOfAisles: number | null;
  numberOfRowsPerAisle: number | null;
  numberOfBaysPerRow: number | null;
  siteType: string | null;
  countryCode: string | null;
  phone: string | null;
  numberOfUnits: number | null;
}

export interface StorageSiteMap {
  id: string;
  storageName: string;
  storageType: "Yard" | "Self Storage" | "Warehouse" | "Container";
  telephoneNo: string;
  facilityType: "Ware House" | "Container Yard" | "Self Storage";
  postCode: string;
  fullAddress: string;
  locationId: string;
  floors: number;
  unitsInEachFloor: number;
  rowsInEachFloor: number;
  baysInARow: number;
  totalUnits: number;
  availableUnits: number;
  completedUnits: number;
  units: StorageUnit[];
}

export interface SiteUnit {
  id: string;
  refNo: string;
  floorNumber: number;
  size: string;
  type: "Small Container" | "Rack" | "Large Container" | "Pallet";
  price: number;
  duration: "Monthly" | "Quarterly" | "Yearly" | "Weekly";
  customerName?: string;
  description: string;
  isAvailable: boolean;
  assignedDate?: string;
}

/**
 * Keyboard codes that should always be allowed through a field's
 * pattern filter (navigation / editing keys), regardless of the
 * field's own `patternAllowed` regex.
 */
export const ALWAYS_ALLOWED_KEY_CODES = [8, 9, 17, 18, 37, 38, 39, 40];

export const NOTES_FIELD_ID = "notes";
export const NOTES_EXPAND_THRESHOLD = 36;

/**
 * Builds a fully-populated UnitType object from the record returned
 * by the API (snake_case) so the form always works with a consistent,
 * camelCase local shape.
 */
export const mapSelectDataToSite = (selectRow: any): Site => ({
  id: selectRow?.id,
  siteName: selectRow?.site_name,
  address: selectRow?.address,
  postcode: selectRow?.postcode,
  status: selectRow?.status,
  numberOfFloors: selectRow?.number_of_floors,
  numberOfAisles: selectRow?.number_of_aisles,
  numberOfRowsPerAisle: selectRow?.rows_per_aisle,
  numberOfBaysPerRow: selectRow?.bays_per_row,
  siteType: selectRow?.site_type,
  countryCode: selectRow?.country_code,
  phone: selectRow?.phone,
  numberOfUnits: selectRow?.number_of_units,
});
